import {makeActionCreator} from '../utility'

export const FETCH_MEMBERSHIP_GRADES = 'FETCH_MEMBERSHIP_GRADES'
export const fetchMembershipGrade = makeActionCreator(FETCH_MEMBERSHIP_GRADES,'data')

export const FETCH_MEMBERSHIP_GRADES_RECEIVED = 'FETCH_MEMBERSHIP_GRADES_RECEIVED'
export const fetchMembershipGradeReceived = makeActionCreator(FETCH_MEMBERSHIP_GRADES_RECEIVED, 'data')